import { useEffect, useState } from "react";
import {
  CrossSearchIcon,
  FilterIcon,
  HideColumnIcon,
  PaddingLG,
  PaddingMD,
  PaddingSM,
  SearchIcon,
} from "../assets/svg";
import "./Topbar.scss";
import DropdownMenu from "./DropdownMenu";
import React from "react";

function Topbar({ table, tableOptions, featuresOptions }) {
  const [openSearch, setOpenSearch] = useState(false);
  const [openColumnHide, setOpenColumnHide] = useState(false);

  const {
    enableTopbar,
    enableFilter,
    enableSearch,
    enableColumnPadding,
    enableColumnHiding,
    enableGlobalFilter,
  } = featuresOptions;

  const {
    globalFilter,
    setGlobalFilter,
    openFilter,
    setOpenFilter,
    paddingIndex,
    setPaddingIndex,
  } = tableOptions;
  return (
    enableTopbar && (
      <section className="ts__topbar">
        {enableSearch && enableGlobalFilter && (
          <>
            {openSearch && (
              <label className="ts_search-field" htmlFor="Search">
                <SearchIcon />
                <DebouncedInput
                  value={globalFilter ?? ""}
                  onChange={(value) => setGlobalFilter(String(value))}
                  placeholder="Search"
                />
              </label>
            )}
            <button
              onClick={() => setOpenSearch(!openSearch)}
              className="ts__topbar__button ts__topbar__search"
            >
              {openSearch ? <CrossSearchIcon /> : <SearchIcon />}
            </button>
          </>
        )}
        {enableFilter && enableGlobalFilter && (
          <button
            onClick={() => {
              setOpenFilter(!openFilter);
            }}
            className="ts__topbar__button ts__topbar__filter"
          >
            <FilterIcon />
          </button>
        )}
        {enableColumnHiding && (
          <button
            onClick={() => setOpenColumnHide(!openColumnHide)}
            className="ts__topbar__button ts__topbar__filter"
          >
            <HideColumnIcon />
          </button>
        )}
        {enableColumnPadding && (
          <button
            onClick={setPaddingIndex}
            className="ts__topbar__button ts__topbar__filter"
          >
            {paddingIndex === 0 && <PaddingSM />}
            {paddingIndex === 1 && <PaddingMD />}
            {paddingIndex !== 0 && paddingIndex !== 1 && <PaddingLG />}
          </button>
        )}
        {openColumnHide && (
          <DropdownMenu top={50} right={60}>
            <div className="ts__hide__show__button">
              <button
                {...{
                  defaultChecked: table.getIsSomeColumnsVisible(),
                  onClick: table.getToggleAllColumnsVisibilityHandler(),
                }}
                className="ts__show__button"
              >
                Toggle All
              </button>
            </div>
            {table.getAllLeafColumns().map((column) => {
              return (
                <div key={column.id} className="ts__column__visible">
                  <label className="ts__column_visible_label">
                    <div className="switch">
                      <input
                        {...{
                          type: "checkbox",
                          checked: column.getIsVisible(),
                          onChange: column.getToggleVisibilityHandler(),
                        }}
                      />
                      <span className="slider round"></span>
                    </div>
                    {column.id}
                  </label>
                </div>
              );
            })}
          </DropdownMenu>
        )}
      </section>
    )
  );
}

export default Topbar;

export function DebouncedInput({
  value: initialValue,
  onChange,
  debounce = 500,
  ...props
}) {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value);
    }, debounce);

    return () => clearTimeout(timeout);
  }, [debounce, onChange, value]);

  return (
    <input
      {...props}
      value={value}
      onChange={(e) => setValue(e.target.value)}
    />
  );
}
